export default __webpack_public_path__ + "static/media/batt.31b20bf6.svg";